module.exports = __webpack_public_path__ + "static/img/solution-8.7047355d.png";